module.exports = __webpack_public_path__ + "img/DPINLogo.bd1efc6c.png";